// extracted by mini-css-extract-plugin
export default {"registration-button":"DsHD-","registrationButton":"DsHD-","disabled":"cWWvM","link":"zN0di"};